export const spacing = {
  xxs: "4px",
  xs: "8px",
  /** 12px — between xs (8px) and sm (16px) */
  smd: "12px",
  sm: "16px",
  /** 20px — between sm (16px) and md (24px) */
  mds: "20px",
  md: "24px",
  lg: "32px",
  xl: "40px",
  "2xl": "48px",
} as const;

export const rounded = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  full: "50%",
} as const;

export const elevation = {
  lv1: "0px 2px 6px 0px #00000026",
  lv2: "0px 4px 10px 0px #00000026",
  lv3: "0px 8px 24px 0px #00000026",
  lv4: "rgba(0, 0, 0, 0.25) 0px 1px 2px 0px",
  lg: "0px 10px 15px -3px #0000001A, 0px 4px 6px -4px #1018281A",
  sm: "0px 1px 2px 0px #1018280D",
} as const;

/**
 * Safe Area constants for mobile layout.
 * Use CSS variables for dynamic values from env().
 */
export const safeArea = {
  top: "var(--safe-area-inset-top)",
  bottom: "var(--safe-area-inset-bottom)",
  left: "var(--safe-area-inset-left)",
  right: "var(--safe-area-inset-right)",
} as const;

/**
 * Mobile layout dimensions.
 * First view target: 600-660px for optimal mobile UX.
 */
export const mobileLayout = {
  bottomNavHeight: "63px",
  bottomNavHeightVar: "var(--mobile-bottom-nav-height)",
  firstViewHeight: "660px",
  containerMaxHeight: "600px",
} as const;

/**
 * Prevent content selection and copying on mobile devices.
 * Spread into the root container's sx prop of practice/quiz/exam pages.
 * Preserves input/textarea selectability.
 */
export const noContentCopy = {
  userSelect: "none",
  WebkitUserSelect: "none",
  WebkitTouchCallout: "none",
  "& input, & textarea": {
    userSelect: "auto",
    WebkitUserSelect: "auto",
    WebkitTouchCallout: "auto",
  },
} as const;
